<template>
  <div v-html="displayContent"></div>
</template>

<script>
// Quill 에디터 스타일 임포트
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
// import "quill-emoji/dist/quill-emoji.css";

export default {
  name: 'QuillContentViewer',
  props: {
    contentData: String,
    metaDataYn: {type: Boolean, default: false}
  },
  
  data() {
    return {
      displayContent: this.contentData || '', 
      blobUrls: []  // 생성된 blob URL들을 추적 (메모리 해제용)
    }
  },

  async mounted() {
    if (this.contentData) {
      // img blob 변환
      this.displayContent = await this.convertImgSrcToBlob(this.contentData);
      
      // 메타데이터 처리
      if (this.metaDataYn) {
        this.processMetaData(this.displayContent);
      }
    }
  },
  
  methods: {
    // img 태그 src blob 변환
    async convertImgSrcToBlob(content) {
      // img 태그의 src 속성을 찾는 정규식
      const imgRegex = /<img\s+[^>]*src="([^"]+)"[^>]*>/gi;
      
      let processedContent = content;
      const matches = [...content.matchAll(imgRegex)];
      
      for (const match of matches) {
        const fullImgTag = match[0];    // 전체 img 태그
        const originalSrc = match[1];   // 원본 src 경로
        
        if (this.shouldConvertToBlob(originalSrc)) {
          try {
            // blob URL 변환
            const blobUrl = await this.fetchImageAsBlob(originalSrc);
            
            // img 태그 내의 src만 교체
            const newImgTag = fullImgTag.replace(`src="${originalSrc}"`, `src="${blobUrl}"`);
            processedContent = processedContent.replace(fullImgTag, newImgTag);
            
            // 생성된 blob URL 추적
            this.blobUrls.push(blobUrl);
            
          } catch(error) {
            // console.error(`이미지 로딩 실패: ${originalSrc}`, error);
          }
        }
      }
      return processedContent;
    },

    // API 경로인 경우만 blob 변환
    shouldConvertToBlob(srcUrl) {
      return srcUrl.startsWith('/api/') || 
             srcUrl.includes('newsCenterImage') ||
             srcUrl.includes('noticeImage');
    },

    // blob URL 변환
    async fetchImageAsBlob(srcUrl) {
      return new Promise((resolve, reject) => {
        if (srcUrl.indexOf('http') === 0 || srcUrl.indexOf('/') === 0) {
          const options = { responseType: 'blob' };
          
          this.$.http(srcUrl, {}, options, 'GET', false)
            .then(res => {
              if (res.data.size === 0) {
                reject(new Error('Empty image data'));
              } else {
                // Blob을 Object URL로 변환
                const blobUrl = window.URL.createObjectURL(res.data);
                resolve(blobUrl);
              }
            })
            .catch(error => {
              reject(error);
            });
        } else if (srcUrl) {
          resolve(srcUrl);
        } else {
          reject(new Error('Invalid src URL'));
        }
      });
    },
    
    // 메타 데이터 처리
    processMetaData(content) {
      if (!content) {
        return '';
      }
      
      // HTML 태그 및 불필요한 문자 제거
      let tempMetaCont = content
        .replace(/<[^>]*>/g, ' ')           // 모든 HTML 태그 제거
        .replace(/\s+/g, ' ')              // 연속된 공백을 하나로
        .replace(/&[^;]+;/g, ' ')          // HTML 엔티티 제거 (&nbsp; 등)
        .trim();                           // 앞뒤 공백 제거

      if (tempMetaCont.length > 120) {
        tempMetaCont = tempMetaCont.substring(0, 120) + ' ...';
      }
      
      // 메타데이터 전달
      this.$emit('metaDataReady', tempMetaCont);
      
      return tempMetaCont;
    }
  },
  
  // 컴포넌트 해제 시 메모리 정리
  beforeDestroy() {
    // 생성된 blob URL들을 해제하여 메모리 누수 방지
    this.blobUrls.forEach(url => {
      window.URL.revokeObjectURL(url);
    });
    this.blobUrls = [];
  }
}
</script>
